import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';
import supabase from '../../lib/supabase';

const { FiLoader, FiCheckCircle } = FiIcons;

const PaymentStatusChecker = ({ orderId, onPaymentConfirmed }) => {
  const [status, setStatus] = useState('checking');
  const [countdown, setCountdown] = useState(30);
  
  useEffect(() => {
    // Start checking payment status
    checkPaymentStatus();
    
    // Set up interval for continuous checking
    const statusInterval = setInterval(checkPaymentStatus, 5000);
    
    // Set up countdown timer
    const countdownInterval = setInterval(() => {
      setCountdown(prev => {
        if (prev <= 1) {
          clearInterval(countdownInterval);
          return 0;
        }
        return prev - 1;
      });
    }, 1000);
    
    return () => {
      clearInterval(statusInterval);
      clearInterval(countdownInterval);
    };
  }, [orderId]);
  
  // Reset countdown when it reaches zero
  useEffect(() => {
    if (countdown === 0) {
      setCountdown(30);
    }
  }, [countdown]);
  
  // Check payment status in database
  const checkPaymentStatus = async () => {
    if (!orderId) return;
    
    try {
      const { data, error } = await supabase
        .from('available_orders_a7b5c9')
        .select('status')
        .eq('order_id', orderId)
        .maybeSingle();

      if (error) {
        // If column missing or no row, treat as pending and continue polling
        return;
      }

      if (data && data.status === 'completed') {
        setStatus('completed');
        onPaymentConfirmed && onPaymentConfirmed();
      }
    } catch (error) {
      console.error('Error in payment status check:', error);
    }
  };

  return (
    <div className="mt-4 pt-4 border-t border-gray-200">
      <div className="flex items-center justify-between">
        <div className="flex items-center">
          {status === 'checking' ? (
            <>
              <motion.div
                animate={{ rotate: 360 }}
                transition={{ duration: 2, repeat: Infinity, ease: "linear" }}
                className="mr-2"
              >
                <SafeIcon icon={FiLoader} className="w-5 h-5 text-blue-600" />
              </motion.div>
              <span className="text-sm text-gray-700">
                Checking payment status... 
                <span className="text-xs text-gray-500 ml-1">
                  (refreshes in {countdown}s)
                </span>
              </span>
            </>
          ) : (
            <>
              <SafeIcon icon={FiCheckCircle} className="w-5 h-5 text-green-600 mr-2" />
              <span className="text-sm font-medium text-green-700">
                Payment received! Processing your order...
              </span>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default PaymentStatusChecker;